import { render, staticRenderFns } from "./MobileProjectsAssessmentReport.vue?vue&type=template&id=961c8234&scoped=true"
import script from "./MobileProjectsAssessmentReport.vue?vue&type=script&lang=js"
export * from "./MobileProjectsAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./MobileProjectsAssessmentReport.vue?vue&type=style&index=0&id=961c8234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c8234",
  null
  
)

export default component.exports